'use client';
import React, { useState } from 'react';
import { LineItem } from 'shared/types/cart';
import Address from '@/components/customercenter-ui/address/guestCheckout/ShippingAddress';
import { useCheckout } from '@/context/checkoutProvider';
import ColorPayment from './ColorPayment';
import Review from './Review';
import PlaceOrderButton from '../orderConfirmation/PlaceOrderButton';

const CheckoutReview = ({ data, cartData, availableShippingMethods }: any) => {
  const { shippingAddress } = useCheckout();
  const [emailError, setEmailError] = useState('');
  let cartHasInsurance = false;
  if (cartData?.lineItems && cartData?.lineItems.length > 0) {
    cartHasInsurance = cartData?.lineItems.some((item: LineItem) => item?.isInsuranceItem);
  }
  return (
    <section>
      <section></section>

      <section className="lg:mb-6">
        <Address
          address={shippingAddress}
          edit={false}
          color={'#298842'}
          cartData={cartData}
          availableShippingMethods={availableShippingMethods}
        />
      </section>
      <section className="lg:mb-6">
        <ColorPayment dataSource={data} edit={true} color={'#298842'} />
      </section>
      <section className="pt-5 lg:mb-6 lg:pt-0">
        <Review emailError={emailError} setEmailError={setEmailError} cartHasInsurance={cartHasInsurance} />
      </section>
      <div className="mb-4 block">
        <PlaceOrderButton setEmailError={setEmailError} cartHasInsurance={cartHasInsurance} />
      </div>
    </section>
  );
};

export default CheckoutReview;
